import api from "./api";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { vividOrangeTheme } from "@totalsoft/rocket-ui";

export function loadApplicationTheme() {
  return async dispatch => {
    try {
      const theme = await dispatch(sendHttpRequest(api.loadApplicationTheme()));
      return theme;
    } catch (error) {
      return vividOrangeTheme;
    }
  };
}
